export const environment = {
  production: true,
  url:"https://todaslaslineas.backend.scc.quosoluciones.com.ar/api/"
};
